import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import RequisitionDetailPage from "@/pages/admin/RequisitionDetailPage";

export const Route = createFileRoute("/_admin/admin/requisitions/$id")({
  head: () => pageHead("Admin · Requisitions", "AKIVA admin · requisitions portal.", "/admin/requisitions/$id", true),
  component: RequisitionDetailPage,
});
